<template>
  <div class="modal fade" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title">Dokument bearbeiten</h4>
        </div>
        <div class="modal-body">
          <div class="flex-box-test">
            <div class="form-group">
              <label for="titel" class="pull-left">{{'title' | translate}}*</label>
              <textarea
                name="title"
                type="text"
                class="form-control"
                :placeholder="'title' | translate"
                v-model="fileData.title"
                rows="2"
                cols="40"
              >
            </textarea>
            </div>
            <div class="form-group">
              <label for="subtitle" class="pull-left">{{'description' | translate}}*</label>
              <textarea
                name="description"
                type="text"
                class="form-control"
                :placeholder="'description' | translate"
                v-model="fileData.subtitle"
                rows="4"
                cols="40"
              >
            </textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            id="closeModal"
            class="btn btn-app btn-outline no-margin pull-left"
            data-dismiss="modal"
            >
            <span class="fa fa-times"></span>
            {{'cancel' | translate}}
          </button>
          <button
            type="button"
            id="confirmEdit"
            class="btn btn-app btn-success"
            data-dismiss="modal"
            @click="send('PUT', fileData)"
            >
            <span class="fa fa-save "></span>
            {{'save' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      type: Object
    }
  },
  data() {
    return {
      fileData: {}
    }
  },
  methods: {
    send(method, data = {note: this.noteBody}) {
      let extra = ''
      if (method === 'PUT') {
        extra = '/' + data.id
        data.sub_title = data.subtitle
        this.loading = true
      }
      API({method: method, url: 'files' + extra, data: data})
        .then(response => {
          this.$emit('close')
          this.$emit('alert', {dismiss: 4, type: 'success', message: 'Success', icon: 'icon fa fa-check', show: true})
        })
    },
  },
  mounted() {},
  watch: {
    file () {
      this.fileData = JSON.parse(JSON.stringify(this.file))
    }
  },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/Modals/EditFileModal.vue